import { DOMAIN_REGEX } from "../../../../constants";
import { US_STATES, CA_STATES } from "../../../../constants";

export const stateOptionsForCountry = (form) => (form?.country === "CA" ? CA_STATES : US_STATES);

export const isModalVariant = (variant) => variant === "modal";

export const validateDomainAt = (values, index) => {
  const list = Array.isArray(values) ? values : [""];
  const value = (list[index] || "").trim();

  if (!value) return list.length > 1 ? "Domain is required" : undefined;
  if (!DOMAIN_REGEX.test(value)) return "Enter a valid domain address";

  const isDuplicate = list.some((entry, i) => i !== index && (entry || "").trim() === value);
  if (isDuplicate) return "Domain already exist";

  return undefined;
};

export const validateDomains = (values) => (Array.isArray(values) ? values : [""]).map((_, index) => validateDomainAt(values, index));

export const hasDomainErrors = (domainErrors) => (domainErrors || []).some(Boolean);

export const canAddDomain = (values) => {
  const list = Array.isArray(values) && values.length ? values : [""];
  const last = (list[list.length - 1] || "").trim();
  return DOMAIN_REGEX.test(last);
};
